import './error.css'
export const Error = () =>{
    return(
        <div>
            <h1>404</h1>
            <h2>Click <a href="/" className="errorlink">here</a> to return to the homepage.</h2>
        </div>
    );
}